import { rachelMediaArray } from './rachelMedia'
import { rachelBio } from './rachelBios'

import { monicaReviewerReviewHinge, rossReviewerReviewBumble, joeyReviewerReviewTinder } from './rachelReviewerReviews'
import { monicaReviewerProfile, rossReviewerProfile, joeyReviewerProfile } from './rachelReviewers'

export const monicaProfileReviewHinge = {
  _id: 'monicaProfileReviewHingeId',
  userId: 'rachelUserId',
  userEmail: 'rachel@email.com',
  datingProfileId: 'rachelDatingProfileHingeId',
  reviewerProfileId: 'monicaReviewerProfileId',
  reviewerEmail: 'monica@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: rachelMediaArray[12]._id,
      mediaItemURL: rachelMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[12].type,
      caption: rachelMediaArray[12].captions[0],
      subcaption: rachelMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[18]._id,
      mediaItemURL: rachelMediaArray[18].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[18].type,
      caption: rachelMediaArray[18].captions[1],
      subcaption: rachelMediaArray[18].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[6]._id,
      mediaItemURL: rachelMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[6].type,
      caption: rachelMediaArray[6].captions[1],
      subcaption: rachelMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[7]._id,
      mediaItemURL: rachelMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[7].type,
      caption: rachelMediaArray[7].captions[1],
      subcaption: rachelMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[4]._id,
      mediaItemURL: rachelMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[4].type,
      caption: rachelMediaArray[4].captions[2],
      subcaption: rachelMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[19]._id,
      mediaItemURL: rachelMediaArray[19].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[19].type,
      caption: rachelMediaArray[19].captions[2],
      subcaption: rachelMediaArray[19].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look great! Lov the hair, the expression, and the coffee cup!`,
      verdict: 'Very',
    },
    {
      feedback: `Cool outfit, but the body language isn't super confident, and I'm not sure how much this photo adds`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Great smile!`,
      verdict: 'Yes',
    },
    {
      feedback: `It's good to show off your friends... your female friends... guys will wonder why you aren't dating one of those handsome men`,
      verdict: 'Somewhat',
    },
    {
      feedback: `This is a funny change of pace. It's already established that you're hot, so the facial expression shows that you can laugh at yourself. Also love the color of the shirt, you look great in it!`,
      verdict: 'Yes',
    },
    {
      feedback: `You look stunning! And I love it feels natural, not so posed`,
      verdict: 'Very',
    }
  ],
  bio: {
    bioItemsId: rachelBio._id,
    vitalInfo: { ...rachelBio.vitalInfo },
    prompts: [
      { ...rachelBio.prompts[0] },
      { ...rachelBio.prompts[1] },
      { ...rachelBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: [],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `People might judge you for being a waitress. Maybe skip the professional part for now until your fashion consultancy is off the ground`,
      verdict: 'Somewhat', 
    },
    aboutMeFeedback: {
      feedback: '',
      verdict: '', 
    },
    promptsFeedback: [
      {
        feedback: `Funny, you saved it with the self deprecating humor at the end`,
        verdict: 'Yes', 
      },
      {
        feedback: `Another funny one that shows personality and self-awareness`,
        verdict: 'Very', 
      },
      {
        feedback: `Funny question but I'm not sure you're gonna want to explain the backstory`,
        verdict: 'No', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Rachel is very pretty, stylish, and funny.`,
    good: `Your style and humor really shine, and you've chosen flattering photos of yourself`,
    notGood: `The final prompt and the friend pic will invite questions about the men who are already in your life`,
    verdict: `Overall you have a great profile already! Just clean up one or two things and you'll be matching with everyone!`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...monicaReviewerReviewHinge },
  reviewerProfile: { ...monicaReviewerProfile },
  bioItems: { ...rachelBio },
  mediaItems: [ ...rachelMediaArray ],
}

export const rossProfileReviewBumble = {
  _id: 'rossProfileReviewBumbleId',
  userId: 'rachelUserId',
  userEmail: 'rachel@email.com',
  datingProfileId: 'rachelDatingProfileBumbleId',
  reviewerProfileId: 'rossReviewerProfileId',
  reviewerEmail: 'ross@email.com',
  isAIReview: true,
  isFriendReview: false,
  nameOfLLM: 'ChatGPT + Gemini',
  modelOfLLM: 'GPT-4o mini + gemini-1.5-flash-8b',
  priceOfReview: 10,
  reviewSubmitted: true,
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: rachelMediaArray[12]._id,
      mediaItemURL: rachelMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[12].type,
      caption: rachelMediaArray[12].captions[0],
      subcaption: rachelMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[18]._id,
      mediaItemURL: rachelMediaArray[18].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[18].type,
      caption: rachelMediaArray[18].captions[1],
      subcaption: rachelMediaArray[18].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[6]._id,
      mediaItemURL: rachelMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[6].type,
      caption: rachelMediaArray[6].captions[1],
      subcaption: rachelMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[7]._id,
      mediaItemURL: rachelMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[7].type,
      caption: rachelMediaArray[7].captions[1],
      subcaption: rachelMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[4]._id,
      mediaItemURL: rachelMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[4].type,
      caption: rachelMediaArray[4].captions[2],
      subcaption: rachelMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[19]._id,
      mediaItemURL: rachelMediaArray[19].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[19].type,
      caption: rachelMediaArray[19].captions[2],
      subcaption: rachelMediaArray[19].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look great! Lov the hair, the expression, and the coffee cup!`,
      verdict: 'Very',
    },
    {
      feedback: `Cool outfit, but the body language isn't super confident, and I'm not sure how much this photo adds`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Great smile!`,
      verdict: 'Yes',
    },
    {
      feedback: `It's good to show off your friends... your female friends... guys will wonder why you aren't dating one of those handsome men`,
      verdict: 'Somewhat',
    },
    {
      feedback: `This is a funny change of pace. It's already established that you're hot, so the facial expression shows that you can laugh at yourself. Also love the color of the shirt, you look great in it!`,
      verdict: 'Yes',
    },
    {
      feedback: `You look stunning! And I love it feels natural, not so posed`,
      verdict: 'Very',
    }
  ],
  bio: {
    bioItemsId: rachelBio._id,
    vitalInfo: { ...rachelBio.vitalInfo },
    prompts: [
      { ...rachelBio.prompts[0] },
      { ...rachelBio.prompts[1] },
      { ...rachelBio.prompts[2] }
    ],
    aboutMe: rachelBio.aboutMe[0],
    hobbies: [rachelBio.hobbies[0], rachelBio.hobbies[1], rachelBio.hobbies[2], rachelBio.hobbies[3], rachelBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `People might judge you for being a waitress. Maybe skip the professional part for now until your fashion consultancy is off the ground`,
      verdict: 'Somewhat', 
    },
    aboutMeFeedback: {
      feedback: `Love the narrative humor. It's funny!`,
      verdict: 'Yes', 
    },
    promptsFeedback: [
      {
        feedback: `Funny, you saved it with the self deprecating humor at the end`,
        verdict: 'Yes', 
      },
      {
        feedback: `Another funny one that shows personality and self-awareness`,
        verdict: 'Very', 
      },
      {
        feedback: `Funny question but I'm not sure you're gonna want to explain the backstory`,
        verdict: 'No', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Rachel is very pretty, stylish, and funny.`,
    good: `Your style and humor really shine, and you've chosen flattering photos of yourself`,
    notGood: `The final prompt and the friend pic will invite questions about the men who are already in your life`,
    verdict: `Overall you have a great profile already! Just clean up one or two things and you'll be matching with everyone!`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...rossReviewerReviewBumble },
  reviewerProfile: { ...rossReviewerProfile },
  bioItems: { ...rachelBio },
  mediaItems: [ ...rachelMediaArray ],
}

export const joeyProfileReviewTinder = {
  _id: 'joeyProfileReviewTinderId',
  userId: 'rachelUserId',
  userEmail: 'rachel@email.com',
  datingProfileId: 'rachelDatingProfileTinderId',
  reviewerProfileId: 'joeyReviewerProfileId',
  reviewerEmail: 'joey@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: rachelMediaArray[12]._id,
      mediaItemURL: rachelMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[12].type,
      caption: rachelMediaArray[12].captions[0],
      subcaption: rachelMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[18]._id,
      mediaItemURL: rachelMediaArray[18].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[18].type,
      caption: rachelMediaArray[18].captions[1],
      subcaption: rachelMediaArray[18].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[6]._id,
      mediaItemURL: rachelMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[6].type,
      caption: rachelMediaArray[6].captions[1],
      subcaption: rachelMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[7]._id,
      mediaItemURL: rachelMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[7].type,
      caption: rachelMediaArray[7].captions[1],
      subcaption: rachelMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[4]._id,
      mediaItemURL: rachelMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[4].type,
      caption: rachelMediaArray[4].captions[2],
      subcaption: rachelMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[19]._id,
      mediaItemURL: rachelMediaArray[19].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[19].type,
      caption: rachelMediaArray[19].captions[2],
      subcaption: rachelMediaArray[19].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look great! Lov the hair, the expression, and the coffee cup!`,
      verdict: 'Very',
    },
    {
      feedback: `Cool outfit, but the body language isn't super confident, and I'm not sure how much this photo adds`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Great smile!`,
      verdict: 'Yes',
    },
    {
      feedback: `It's good to show off your friends... your female friends... guys will wonder why you aren't dating one of those handsome men`,
      verdict: 'Somewhat',
    },
    {
      feedback: `This is a funny change of pace. It's already established that you're hot, so the facial expression shows that you can laugh at yourself. Also love the color of the shirt, you look great in it!`,
      verdict: 'Yes',
    },
    {
      feedback: `You look stunning! And I love it feels natural, not so posed`,
      verdict: 'Very',
    }
  ],
  bio: {
    bioItemsId: rachelBio._id,
    vitalInfo: { ...rachelBio.vitalInfo },
    prompts: [
      { ...rachelBio.prompts[0] },
      { ...rachelBio.prompts[1] },
      { ...rachelBio.prompts[2] }
    ],
    aboutMe: rachelBio.aboutMe[0],
    hobbies: [rachelBio.hobbies[0], rachelBio.hobbies[1], rachelBio.hobbies[2], rachelBio.hobbies[3], rachelBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `People might judge you for being a waitress. Maybe skip the professional part for now until your fashion consultancy is off the ground`,
      verdict: 'Somewhat', 
    },
    aboutMeFeedback: {
      feedback: `Love the narrative humor. It's funny!`,
      verdict: 'Yes', 
    },
    promptsFeedback: [
      {
        feedback: `Funny, you saved it with the self deprecating humor at the end`,
        verdict: 'Yes', 
      },
      {
        feedback: `Another funny one that shows personality and self-awareness`,
        verdict: 'Very', 
      },
      {
        feedback: `Funny question but I'm not sure you're gonna want to explain the backstory`,
        verdict: 'No', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Rachel is very pretty, stylish, and funny.`,
    good: `Your style and humor really shine, and you've chosen flattering photos of yourself`,
    notGood: `The final prompt and the friend pic will invite questions about the men who are already in your life`,
    verdict: `Overall you have a great profile already! Just clean up one or two things and you'll be matching with everyone!`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...joeyReviewerReviewTinder },
  reviewerProfile: { ...joeyReviewerProfile },
  bioItems: { ...rachelBio },
  mediaItems: [ ...rachelMediaArray ],
}